import {MenuItem} from '@material-ui/core';
import React from 'react';
import {InvoiceActionType} from './InvoiceActionHelper';
import {useHistory} from 'react-router-dom';

const InvoiceDetailsAction = React.forwardRef(({ invoice, closeMenu, label }: InvoiceActionType, ref: React.Ref<any>) => {
  let history = useHistory();
  return (
    <MenuItem
      ref={ref}
      key={invoice.id + 'details'}
      onClick={() => {
        closeMenu();
        history.push(`/dashboard/transactions/invoices/${invoice.id}/`);
      }}
    >
      {label}
    </MenuItem>
  );
});

export default InvoiceDetailsAction;
